/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=0e4c836a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0e4c836a&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4c836a"]])

export default __exports__